package com.essntl.features.service.ui.components.richtext

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsSmallIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.richeditor.model.RichTextState

@Composable
fun RichEditorPanelTypeItem(
    richTextState: RichTextState,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
) {
    val esTypography = MaterialTheme.esTypography
    val types =
        remember {
            listOf(
                esTypography.p1Regular16 to "Small",
                esTypography.h4SemiBold20 to "Medium",
                esTypography.h3Regular24 to "Large",
            )
        }
    var isTypeDropDownExpanded by remember { mutableStateOf(false) }

    val selectedType =
        remember(types, richTextState.currentSpanStyle) {
            types.find { (type, _) ->
                richTextState.currentSpanStyle.equals(type)
            } ?: types.first()
        }

    Box {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier =
                modifier
                    .focusProperties { canFocus = false }
                    .height(28.dp)
                    .clip(RoundedCornerShape(8.dp))
                    .pointerHoverIcon(PointerIcon.Hand)
                    .clickable(enabled = enabled) {
                        isTypeDropDownExpanded = true
                    }
                    .padding(horizontal = 1.5f.spacing),
        ) {
            Text(
                text = selectedType.second,
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p2Medium14,
            )

            Spacer(modifier = Modifier.width(1.spacing))

            EsSmallIcon(
                res = EsIcons.ArrowDown,
            )
        }

        EsDropDownMenu(
            expanded = isTypeDropDownExpanded,
            onDismissRequest = { isTypeDropDownExpanded = false },
        ) {
            types.forEach { (type, name) ->
                val isSelected = richTextState.currentSpanStyle.equals(type)

                EsDropdownMenuItem(
                    text = name,
                    selected = isSelected,
                    onClick = {
                        if (!isSelected) {
                            richTextState.addSpanStyle(type.toSpanStyle())
                            richTextState.addParagraphStyle(type.toParagraphStyle())
                        }

                        isTypeDropDownExpanded = false
                    },
                )
            }
        }
    }
}
